var _g, _line, _rect, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFMouldingRodSill01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 212 232",
    enableBackground: "new 0 0 212 232",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 55.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 105,
    height: 145.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 63.8,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 1.1243,
    strokeMiterlimit: 10,
    width: 87.7,
    height: 128.5
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 1.0384,
    x1: 0,
    y1: 227.3,
    x2: 183,
    y2: 227.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    fill: "none",
    width: 212,
    height: 232
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.212,
    x1: 44.4,
    y1: 21.4,
    x2: 44.4,
    y2: 195.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "40.8,22.4 44.4,16.1 48,22.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "40.8,194.4 44.4,200.7 48,194.4  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M191.8,227.8c-0.3,0-0.6-0.1-0.8-0.2c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0.2-0.7,0.3c-0.3,0.1-0.5,0.1-0.9,0.1h-0.1c-0.3,0-0.6,0-0.8-0.1 c-0.2-0.1-0.5-0.2-0.6-0.4c-0.2-0.2-0.3-0.3-0.4-0.5c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.1,0-0.3,0-0.4s0-0.3,0-0.4c0-0.1,0-0.2,0.1-0.4 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.1-0.3,0.2-0.4l0.5,0.4c0,0-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3 c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.2,0.1,0.2 c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.2,0.1,0.4,0.2c0.1,0,0.3,0.1,0.5,0.1h0c0,0,0,0,0,0c0,0,0,0,0,0 c0.5,0,0.8-0.1,1.1-0.3c0.3-0.2,0.5-0.4,0.6-0.7c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4,0-0.5s-0.1-0.3-0.1-0.5 c-0.1-0.1-0.1-0.3-0.2-0.4c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0l0.6-0.4c0,0,0,0.1,0.1,0.1 c0,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0 c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2-0.1,0.2C192,227.8,191.9,227.8,191.8,227.8z M189.3,225.9l-0.5,0.5 l-0.5-0.5l0.5-0.5L189.3,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M191.5,227.5c0-0.1,0-0.2,0.1-0.2s0.1-0.1,0.2-0.1h0.3c0.2,0,0.4,0,0.5,0c0.2,0,0.3-0.1,0.4-0.1 c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3-0.1-0.5l0.6-0.2c0,0.1,0,0.2,0.1,0.2 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.2 c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1 c0,0-0.1,0-0.1,0c-0.2,0-0.4,0-0.6-0.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.1 c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0h-0.3c-0.1,0-0.2,0-0.2-0.1S191.5,227.6,191.5,227.5z M192.9,229.1l-0.5,0.5l-0.5-0.5 l0.5-0.5L192.9,229.1z M194.2,229.1l-0.5,0.5l-0.5-0.5l0.5-0.5L194.2,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M194.4,227.5c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1h0c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.1,0.3-0.2 s0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.2,0.4-0.4,0.7-0.4 c0.3,0,0.6,0.1,0.8,0.4c0.2,0.2,0.3,0.5,0.3,0.8c0,0.2,0,0.3,0,0.4c0,0.1,0,0.3-0.1,0.4c-0.1,0.2-0.1,0.3-0.3,0.4 c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0.1-0.5,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.7-0.4c0,0,0,0,0,0c-0.3,0.3-0.7,0.5-1.3,0.5h0 c-0.1,0-0.2,0-0.2-0.1C194.4,227.7,194.4,227.6,194.4,227.5z M196.3,226.8c0.2,0.1,0.4,0.3,0.5,0.3c0.2,0.1,0.3,0.1,0.4,0.1 c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1 c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2 s-0.1,0.2-0.1,0.3L196.3,226.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M200.2,225.7c0.1,0.2,0.1,0.4,0.2,0.6c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.2,0.1,0.3c0,0.1,0,0.2,0.1,0.3 c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.1,0.4-0.2,0.5c-0.1,0.2-0.2,0.3-0.4,0.5 c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0.2-0.5,0.3l-0.3-0.6c0.2-0.1,0.5-0.2,0.7-0.4 c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.2-0.4,0.2-0.6c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1v0c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2-0.1-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2-0.1-0.2c-0.1-0.2-0.1-0.4-0.2-0.6L200.2,225.7z M200.3,224.3l-0.5,0.5 l-0.5-0.5l0.5-0.5L200.3,224.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M207.8,227C207.8,227.1,207.8,227.1,207.8,227C207.8,227.1,207.8,227.1,207.8,227c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1 c0,0-0.1,0-0.1,0c-0.3,0-0.6,0-0.8-0.1c-0.3,0-0.5-0.1-0.7-0.2c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.4,0.1 c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0c-0.7,0-1.2-0.1-1.7-0.3c-0.4-0.2-0.8-0.4-1-0.8 c-0.1-0.1-0.1-0.3-0.2-0.5c0-0.2,0-0.3,0-0.4c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1,0-0.1 l0.6,0.3c0,0,0,0,0,0.1c0,0,0,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4,0,0.7,0.1c0.2,0,0.4,0,0.5,0 c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c-0.3-0.2-0.5-0.5-0.5-0.9c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.4,0.3-0.5 c0.1-0.1,0.3-0.3,0.4-0.3c0.2-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0.1,0.1,0.1,0.2 c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.4C208.1,226.5,208,226.8,207.8,227z M207,226.9 c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.2c0-0.2,0-0.3-0.1-0.4 c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1s-0.1,0.1-0.2,0.2 c-0.1,0.1-0.1,0.2-0.1,0.3s-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.3C206.7,226.7,206.8,226.8,207,226.9L207,226.9z M207.5,223.4 L207,224l-0.5-0.5l0.5-0.5L207.5,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M208.3,227.5c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.2-0.1,0.3-0.1h0.3c0.1,0,0.3,0,0.4,0s0.3,0,0.4,0 c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.2-0.2-0.3 c-0.1-0.1-0.2-0.3-0.4-0.5c-0.1-0.2-0.3-0.3-0.5-0.5c-0.2-0.2-0.4-0.3-0.5-0.5l0.1-0.7l2.7-1.2l0.3,0.6l-2.4,1 c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.2,0.4,0.4c0.2,0.2,0.3,0.4,0.4,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.3,0.1,0.4 c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2-0.1,0.3s-0.1,0.2-0.1,0.3c-0.2,0.3-0.5,0.6-1,0.7c-0.1,0-0.2,0-0.3,0h-1.1c-0.1,0-0.2,0-0.3-0.1 C208.3,227.7,208.3,227.6,208.3,227.5z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 10.8,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.6316,
    width: 127.5,
    height: 4.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.7,
    y: 9.4,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.566,
    width: 12,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4,
    y: 9.5,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.5586,
    width: 12,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 161.7,
    y: 7.2,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.3775,
    width: 2.6,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 7.2,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.3775,
    width: 2.6,
    height: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B3B2B2",
    stroke: "#727171",
    strokeWidth: 0.2282,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 187.5,27.7 191,24.1 21.1,24.1 24.4,27.7 187,27.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 7.2,
    opacity: 0.7,
    fill: "#C7C6C7",
    stroke: "#727171",
    strokeWidth: 0.2161,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 170,
    height: 16.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFMouldingRodSill01);
export default __webpack_public_path__ + "static/media/FMouldingRod-Sill01.612c070dcf2dcac5224d31d7cc3a60f0.svg";
export { ForwardRef as ReactComponent };